import { Accordion, AccordionHeader, AccordionItem, AccordionPanel } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Country, ProgramRegion } from '../../../models';
import { FlexBox } from '../../shared-components/flex-box';
import './RegionalCountriesAccordion.scss';

interface Props {
  regions: ProgramRegion[];
  onCountrySelected(country: Country): void;
  onRegionSelected(region: ProgramRegion): void;
}

const RegionalCountriesAccordion: React.FC<Props> = props => {
  const { regions, onCountrySelected, onRegionSelected } = props;

  const renderCountry = (country: Country) => (
    <button
      onClick={() => onCountrySelected(country)}
      className='panel__item'
    >
      {country.displayName}
    </button>
  );

  return (
    <FlexBox
      direction='column'
      className='regional-countries-accordion'
    >
      <Accordion
        collapsible
        className='regional-countries-accordion__accordion'
      >
        {
          regions.map((region, index) => (
            <AccordionItem
              key={`region-content-${region.regionId}`}
              value={index + 1}
            >
              <AccordionHeader
                onClick={() => onRegionSelected(region)}
              >
                {region.displayName}
              </AccordionHeader>
              <AccordionPanel>
                {region.countries.map(country => (
                  <React.Fragment key={country.countryId}>
                    {renderCountry(country)}
                  </React.Fragment>
                ))}
              </AccordionPanel>
            </AccordionItem>
          ))
        }
      </Accordion>
    </FlexBox>
  );
}

export default observer(RegionalCountriesAccordion);
